import { useState } from "react";
import axios from "axios";
import * as api from "../api/index";

export const useUploadForm = (url) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [progress, setProgress] = useState(0);

  const reset = () => {
    setIsSuccess(false);
    setProgress(0);
  };

  const uploadForm = async (fileData, file, metaData) => {
    const { safeName } = makeSafeFilename(fileData.filename, 20);

    // Use safeName for blob
    const { data } = await api.createFileEntry(safeName, metaData);
    const { uploadURL, fileID } = data.data;

    // 🔹 Upload directly to Azure Blob Storage (no Authorization header needed!)
    await axios.put(uploadURL, file, {
      headers: {
        "x-ms-blob-type": "BlockBlob",
        "Content-Type": file.type || "application/octet-stream",
      },
      onUploadProgress: (progressEvent) => {
        const progress = (progressEvent.loaded / progressEvent.total) * 100;
        setProgress(progress);
      },
    });

    // 🔹 Notify backend that upload is complete
    const datacomplete = await api.uploadCompleted(fileID);

    setIsSuccess(true);
    setProgress(0);

    return datacomplete;
  };

  return { uploadForm, isSuccess, progress, reset };
};

function makeSafeFilename(originalName, maxLength = 20) {
  // Split name and extension
  const parts = originalName.split(".");
  const ext = parts.length > 1 ? "." + parts.pop() : "";
  let base = parts.join(".");

  // Truncate base name to maxLength
  if (base.length > maxLength) {
    base = base.substring(0, maxLength);
  }

  // Encode once
  let safeName = encodeURIComponent(base + ext);

  // Double-encode '+' specifically
  safeName = safeName.replace(/%2B/g, "%252B");

  return { safeName, displayName: base + ext };
}
